import React from 'react';
import { Row, Col, Card } from '@paypalcorp/pp-react';
import styles from './ImageListWithNumberedCard.module.less';
import TextBadge from '../../../components/TextBadge';
import Image from '../../../components/Image';

interface ImageListWithNumberedCardProps {
  ecmContent: {
    jsonObject: Array<{ image: string; description: string; width: number; height: number }>;
  };
}

const ImageListWithNumberedCard = ({ ecmContent }: ImageListWithNumberedCardProps) => {
  const { jsonObject = [] } = ecmContent || {};
  return (
    <div className={styles.container}>
      <Row>
        {jsonObject.map(({ image, description, width, height }, index) => {
          return (
            <Col key={index} xs={12} md={4} className={styles.column}>
              <Image
                className={styles.image}
                imageConfig={{ src: image, width: width, height: height }}
              />
              <Card className={styles.card}>
                <div className={styles.card_content}>
                  <TextBadge text={`${index + 1}`} />
                  <p className={styles.description}>{description}</p>
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default ImageListWithNumberedCard;
